import { useSecurityMode } from './SecurityModeContext';
import { RuleMetadata, SecuredFlag } from './types';

const FLAG_METADATA_NULL = null as RuleMetadata | null;

/**
 * Low-level primitive. Prefer {@link useSecuredFlag} for the common
 * permission/feature/state pattern; reach for this only when a rule's logic
 * doesn't fit the declarative shape.
 */
export function useRegisterSecuredFlag(id: string, evaluate: () => boolean, metadataThunk?: () => RuleMetadata): SecuredFlag {
  const { registry } = useSecurityMode();
  const granted = evaluate();

  if (registry == null) {
    return { id, granted, metadata: FLAG_METADATA_NULL };
  }

  const metadata = metadataThunk ? metadataThunk() : null;
  const flag: SecuredFlag = { id, granted, metadata };
  registry.registerFlag(flag);
  return flag;
}